<mat-card appearance="outlined" id="authorize-form-card">
  <mat-card-content>

    @if (clientError) {
      <div fxLayout="column" fxLayoutAlign="center center" class="authorize-form-container">
        Unknown client. Check your query parameters and try again. If the problem persists, contact customer support.
      </div>
    }

    @if (!clientError && client) {
      <div fxLayout="column" fxLayoutAlign="center center" class="authorize-form-container">
        <h4>{{client.name}} would like permission to access your Carnegie Learning account.</h4>
        <div fxLayout="row" fxLayoutAlign="center space-between">
          <button
            type="button"
            mat-raised-button
            color="secondary"
            (click)="deny()"
            >
            Deny
          </button>
          <button
            type="submit"
            mat-raised-button
            color="primary"
            (click)="authorize()"
            >
            Authorize
          </button>
        </div>
      </div>
    }
  </mat-card-content>
</mat-card>
